<template>
    <div>
        <ul class="nav nav-tabs" id="tabs" role="tablist" style="margin-top:25px">
            <li class="nav-item">
                <a class="nav-link isprint-tab active statistiche" data-toggle="tab" id="linkAgenti"
                    data-tab="statsContratti" href="#statsContratti" role="tab" aria-controls="statsContratti"
                    aria-selected="false">
                    <i class="fal fa-truck"></i> Contratti
                </a>
            </li>


        </ul>
        <div class="tab-content card-tab" style="margin-top:-20px">
            <div class="tab-pane active" id="statsContratti" style="height:100%" role="tabpanel">
                <div class="card shadow" style="margin-top:20px;height:100%">
                    <div class="card-header" style="height:70px">
                        <div class="row">
                            <div class="form-group ml-4 mt-3 float-left">
                                <i class="fal fa-filter fa-2x"></i>
                            </div>



                            <div class="form-group mt-1 mr-2" style="border-left:1px solid #ccc;padding-left:20px">
                                <label>Agente</label>
                                <select class="form-control form-control-sm"
                                    v-model="searchStatsContratti.FK_ID_AGENTE.VALUE">
                                    <option value="0">Tutti</option>>
                                    <option v-for="agente in arrayAgenti" v-bind:value="agente.ID_AGENTE"
                                        v-bind:key="agente.ID_AGENTE">{{ agente.DESCRIZIONE_AGENTE }}</option>
                                </select>
                            </div>

                            <div class="form-group mt-1 mr-2" style="border-left:1px solid #ccc;padding-left:20px">
                                <label>Tipologia</label>
                                <select class="form-control form-control-sm"
                                    v-model="searchStatsContratti.FK_ID_TIPO.VALUE">
                                    <option value="0">Luce e gas</option>
                                    <option value="1">Luce</option>
                                    <option value="2">Gas</option>
                                </select>
                            </div>

                            <div class="form-group mt-1 mr-2" style="border-left:1px solid #ccc;padding-left:20px">
                                <label>Regione</label>
                                <select class="form-control  form-control-sm"
                                    v-model="searchStatsContratti.FK_ID_REGIONE.VALUE">
                                    <option value="0">Tutte</option>>
                                    <option v-for="regione in arrayRegioni" v-bind:value="regione.ID_REGIONE"
                                        v-bind:key="regione.ID_REGIONE">{{ regione.NOME }}</option>
                                </select>
                            </div>

                            <div class="form-group mt-1 mr-2" style="border-left:1px solid #ccc;padding-left:20px">
                                <label>Provincia</label>
                                <select class="form-control  form-control-sm"
                                    v-model="searchStatsContratti.FK_ID_PROVINCIA.VALUE">
                                    <option value="0">Tutte</option>>
                                    <option v-for="provincia in arrayProvince" v-bind:value="provincia.ID_PROVINCIA"
                                        v-bind:key="provincia.ID_PROVINCIA">{{ provincia.NOME }}</option>
                                </select>
                            </div>

                            <div class="form-group mt-1 mr-2" style="border-left:1px solid #ccc;padding-left:20px">
                                <label>Comune</label>
                                <Select2 v-model="searchStatsContratti.FK_ID_COMUNE.VALUE" :w="189"
                                    :api="'core/geo/comuni/select2'"></Select2>
                            </div>


                            <button class="btn btn-info btn-sm" v-on:click="getStatisticheContratti()"
                                style="height: 30px;margin-top: 30px;"><i class="fa fa-sync"></i></button>


                        </div>
                    </div>
                    <div class="card-body" style="min-height: 500px;">
                        <div class="card-body grafico" id="chart1" style="min-height: 500px;">

                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>

import Select2 from '@/components/utils/Select2.vue'


export default {
    name: "Statistiche",
    components: {
        Select2,

    },
    props: [],
    data: function () {
        return {
            filters: global.filters,
            searchStatsContratti: {
                FK_ID_AGENTE: { TYPE: 'COMBO', VALUE: 0 },
                FK_ID_COMUNE: { TYPE: 'COMBO', VALUE: 0 },
                FK_ID_PROVINCIA: { TYPE: 'COMBO', VALUE: 0 },
                FK_ID_REGIONE: { TYPE: 'COMBO', VALUE: 0 },
                FK_ID_TIPO: { TYPE: 'COMBO', VALUE: 0 },
            },
            arrayAgenti: new Array(),
            arrayRegioni: new Array(),
            arrayProvince: new Array(),
            searchStatsContrattiArticoliPaginazione: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
            },

            searchStatsContrattiStati: {
                DATA_ORDINE: { TYPE: 'DATE_RANGE', VALUE_FROM: '', VALUE_TO: '' },
            },
            arrayMesi: new Array(),
            arrayAnniAgenti: new Array({ ANNO: new Date().getFullYear() }, { ANNO: new Date().getFullYear() - 1 }, { ANNO: new Date().getFullYear() - 2 })
        }
    },
    methods: {
        getStatisticheContratti: function () {
            $('.grafico').removeAttr("_echarts_instance_");
            $('.grafico').empty();
            utils.post('/es/statistiche/contratti', this.searchStatsContratti, (response) => {
                var option = {};
                //var chart1 = echarts.init(document.getElementById('chart1'));
                let chart1 = echarts.getInstanceByDom(document.getElementById('chart1')); // get some words DOM node has echarts instance.
                if (chart1 == null) {// If not, it is initialized.
                    chart1 = echarts.init(document.getElementById('chart1'));
                }

                var arrayDistinctMesi = utils.array.distinct(response.data, "MESE", "MESE");
                var arrayDistinctAnni = utils.array.distinct(response.data, "ANNO", "ANNO");
                var series = new Array();
                var arrayAnni = [];
                arrayDistinctAnni = utils.array.ordinaArray(arrayDistinctAnni, "ANNO");
                for (var i = 0; i < arrayDistinctAnni.length; i++) {
                    arrayAnni.push(arrayDistinctAnni[i].ANNO.toString());
                }
                var arrayMesi = [];
                for (var i = 0; i < arrayDistinctMesi.length; i++) {
                    arrayMesi.push(utils.array.select(utils.arrayMesi, "ID_MESE", arrayDistinctMesi[i].MESE, 1)[0].DESCRIZIONE);
                }
                //arrayMesi = utils.array.ordinaArray(arrayMesi,"ID_MESE");
                
                for (var i = 0; i < arrayDistinctAnni.length; i++) {
                    var serie = {
                        name: arrayDistinctAnni[i].ANNO.toString(),
                        type: 'bar',
                        barGap: 0.2,
                        data: []
                    };
                    for (var j = 0; j < arrayDistinctMesi.length; j++) {
                        var trovato = 0;
                        for (var k = 0; k < response.data.length; k++) {
                            if (response.data[k].MESE == arrayDistinctMesi[j].MESE && response.data[k].ANNO == arrayDistinctAnni[i].ANNO) {
                                trovato = 1;
                                serie.data.push(parseFloat(response.data[k].TOT));
                                break;
                            }
                        }
                        if (trovato == 0) {
                            serie.data.push(0);
                        }
                    }
                    series.push(serie);
                }
                option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: (params) => {
                            return "<strong>" + params.name + " " + params.seriesName + "</strong><br/>" + (params.data) + " ATTIVAZIONI ";
                        }
                    },
                    legend: {
                        data: arrayAnni
                    },
                    toolbox: {
                        show: true,
                        orient: 'vertical',
                        left: 'right',
                        top: 'center',
                        feature: {
                            mark: { show: true },
                            magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                            restore: { show: true },
                            saveAsImage: { show: true }
                        }
                    },
                    xAxis: [
                        {
                            type: 'category',
                            axisTick: { show: false },
                            data: arrayMesi
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            axisLabel: {
                                formatter: (param) => {
                                    return utils.formatNumberInt(param);//"<strong>" + params.name + " " +  params.seriesName + "</strong><br/>"+ params.data ;
                                }
                            },
                        }
                    ],
                    series: series
                };
                chart1.setOption(option);

            });
        },

    },
    watch: {

    },
    computed: {

    },
    beforeCreate: function () {
        global.utils.deltaGriglia = 80;
    },
    unmounted: function () {
        global.utils.deltaGriglia = 0;
    },
    beforeCreate: function () {
        setTimeout(() => {
            global.utils.deltaGriglia = 100;
            global.utils.resizeContent();
        }, 300);
    },
    unmounted: function () {
        global.utils.deltaGriglia = 0;
    },
    created: function () {
        this.arrayMesi = utils.clone(utils.arrayMesi);
        /*
         setTimeout(() => {
             $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
                 var tab = $(e.target).data("tab");
                 console.log(tab);
                 switch(tab){
                     case 'statspagamenti':
                         this.getStatisticheContratti();
                         break;
                     case 'statsArticoli':
                         this.getStatisticheArticoli();
                         break;
                     case 'statsContratti':
                         this.getStatisticheAgenti();
                         break;
                     case 'statsStati':
                         this.getStatisticheStati();
                         break;
 
                 }
             });            
         },300);*/
        utils.get('es/statistiche/statup', {}, (response) => {
            this.arrayAgenti = response.data.AGENTI;
            this.arrayRegioni = response.data.REGIONI;
            this.arrayProvince = response.data.PROVINCE;
            this.getStatisticheContratti()
        });

    }
}

</script>